module.exports = "/packs/sns-twitter-13caa615613e8f25cd7c2633d5952b9d.png";